import {
  ThemeOptions,
  WBDesignSystemProvider,
  WBSnackbarProvider,
} from '@admiin-com/ds-web';
import { darkTheme, theme } from '@admiin-com/ds-design-token';
import { deepmerge } from 'deepmerge-ts';
import { Routes, Route, Navigate } from 'react-router-dom';
import SignIn from './pages/SignIn/SignIn';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ChangePassword from './pages/ChangePassword/ChangePassword';
import Entities from './pages/Entities/Entities';
import Entity from './pages/Entity/Entity';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import { PATHS } from './navigation/paths';
import './i18n';

const appTheme: ThemeOptions = deepmerge(theme, {});
const appDarkTheme: ThemeOptions = deepmerge(darkTheme, {});

export function App() {
  return (
    <WBDesignSystemProvider theme={appTheme} darkTheme={appDarkTheme}>
      <WBSnackbarProvider>
        <Routes>
          <Route path={PATHS.signIn} element={<SignIn />} />
          <Route path={PATHS.resetPassword} element={<ResetPassword />} />
          <Route path={PATHS.changePassword} element={<ChangePassword />} />
          <Route
            path={PATHS.entities}
            element={
              <ProtectedRoute>
                <Entities />
              </ProtectedRoute>
            }
          />
          <Route
            path={PATHS.entity()}
            element={
              <ProtectedRoute>
                <Entity />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Navigate to={PATHS.entities} replace />
              </ProtectedRoute>
            }
          />
        </Routes>
      </WBSnackbarProvider>
    </WBDesignSystemProvider>
  );
}

export default App;
